// extracted by mini-css-extract-plugin
export default {"container":"src-pages-ProductEditor-Components-Image-css__container--gO1Tp"};